import type { PlanTableTemplate } from 'src/domain/planTables/types'
import { getRequest } from '../utils'

export const getPlanTableTemplates: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['getPlanTableTemplates', projectGuid],
  request: async (projectGuid: string): Promise<PlanTableTemplate[]> => {
    const { data } = await getRequest<PlanTableTemplate[]>({
      url: `/projects/${projectGuid}/plan-table-templates`,
    })

    return data || []
  },
}
